<template>
  <div>
    <div class="mb-6">
      <div
        class="d-flex justify-space-between align-center font-weight-bold mb-5"
      >
        <span class="font-weight-bold title text-black">
          Recent Payments
        </span>
        <router-link
          :to="{ name: 'payments' }"
          class="font-weight-bold subtitle-1"
        >
          All Payments
          <v-icon color="primary" size="16px">$next</v-icon>
        </router-link>
      </div>
    </div>
    <div>
      <v-skeleton-loader
        v-if="!transactionModel.fetched && transactionModel.fetching"
        type="list-item-two-line"
      />
      <div v-else>
        <div v-if="!transactions.length" class="text--secondary">
          No Recent Payments
        </div>
      </div>
    </div>
    <div
      v-for="(transaction, index) in transactions"
      :key="index"
      class="d-flex justify-space-between align-center"
    >
      <div class="d-flex align-center mb-4">
        <v-list-item color="primary" class="pl-0">
          <v-list-item-content>
            <v-list-item-title
              class="body-2 font-weight-bold letter-spacing-compact"
            >
              {{ transaction.subject.name }}
            </v-list-item-title>
            <span class="caption">$ {{ transaction.amount }}</span>
          </v-list-item-content>
        </v-list-item>
      </div>

      <v-chip
        small
        class="caption amber accent-2 font-weight-bold text-transform-uppercase"
        label
      >
        {{ transaction.type === 'credit' ? 'Incoming' : 'Payout' }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import Transaction from '@models/Transaction';
export default {
  name: 'RecentTransactions',
  data() {
    return {
      transactions: [],
      transactionModel: new Transaction({
        filters: {
          user_id: this.$store.state.auth.user.id,
        },
        relations: ['subject'],
        itemsPerPage: 10,
        sortBy: ['created_at'],
        sortDesc: [true],
      }),
    };
  },
  methods: {
    async fetchTransactions() {
      let response = await this.transactionModel.get();
      if (response.data) {
        this.transactions = response.data;
      }
    },
  },
  mounted() {
    this.fetchTransactions();
  },
};
</script>

<style lang="scss" scoped></style>
